import { format } from 'date-fns';

export default function dateTransformer(value?: Date, timezone = 'Europe/Vienna') {
  if (!value) {
    return value;
  }

  const dateMatches =
    value.toString().match(
      // eslint-disable-next-line
      /^(\d{4})(-(\d{2}))??(-(\d{2}))??(T(\d{2}):(\d{2})(:(\d{2}))??(\.(\d+))??(([\+\-]{1}\d{2}:\d{2})|Z)??)??$/gm,
    ) ?? [];

  if (Object.prototype.toString.call(value) === '[object Date]' || dateMatches.length > 0) {
    const date = new Date(value);
    return dateTimezoneTransformer(date, timezone);
  }

  return false;
}

export function dateTransformerNoTimezone(value: string, dateFormat = 'dd.MM.yyyy') {
  if (!value || value === '-') {
    return value;
  }
  const date = new Date(value);
  return format(date, dateFormat);
}

export const dateTimezoneTransformer = (date: string | number | Date | undefined, timezone = 'Europe/Vienna', showTime = false) => {
  if (showTime) {
    // @ts-ignore
    return new Date(date).toLocaleTimeString('ro-RO', {
      timeZone: timezone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
  }
  // @ts-ignore
  return new Date(date).toLocaleString('ro-RO', {
    timeZone: timezone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};

export const dateTimeTransformer = (value: string, timezone = 'Europe/Vienna') => {
  if (!value) {
    return value;
  }
  const date = new Date(value);
  return dateTimezoneTransformer(date, timezone, true);
};
